import { Image } from '@/shared/Components';
import { PATH } from '@/shared/constants';

const Moon = () => {
  return (
    <Image
      src={`${PATH.MEDIA_YOZM_IMAGE}/moon.png`}
      alt="달"
      width={24}
      height={24}
      unoptimized
    />
  );
};

export default Moon;
